/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/graph_decrease_medium'
export default icon
